import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DocketParts from './DocketParts';
import LoadingBar from '../../common/LoadingBar';
import loadingBarImage from '../../../images/loadingBar.gif';


const DocketEntries = (props) => {
  const {
    lastUpdated,
    dockets,
    redactSeqNum,
    buyMissingDockets,
    getDocketDetails,
    buyPdf,
    showRedactPopup,
    onPopupClick,
    case_uuid,
    selectedDocketDetailNum,
    sortDockets,
    updateClick,
    pastEntriesClick,
    entries,
    showMissingDockets,
    reloadDetails,
  } = props;

  const { docketDetails = {} } = dockets;

  let itemRows = null;

  if (_.isEmpty(entries)) {
    itemRows = <tr><td colSpan="4"> No Dockets Found</td></tr>;
  } else {
    itemRows = entries.reduce((accum, p, idx) => {
      const key = `docket-entry-${idx}`;

      if (p.missing) {
        if (!showMissingDockets) {
          return accum;
        }
        accum.push((
          <tr className="missing-dockets" key={key}>
            <td colSpan="5">
              <div>
                <span>Missing Docket Entries</span>
                <button onClick={buyMissingDockets.bind(null, p.missing)}>Fetch Missing Entries Now</button>
              </div>
            </td>
          </tr>
        ));
        return accum;
      }

      const { text, meta } = p;

      const colorClasses = {
        0: 'in-pacer',
        1: 'in-inforuptcy',
        2: 'purchased',
      };

      const docketNumLink = (!text.docket_uri)
        ? (text.docket_no || null)
        : (
          <div className={`view_details ${colorClasses[meta.purchased || 0]}`}
               onClick={getDocketDetails.bind(null, text.docket_seq)}>
            <strong> {text.docket_no || 'doc'} </strong>
          </div>
        );

      const loadingOrRedact = (redactSeqNum === text.docket_seq)
        ? (
          <div className="loading-bar">
            <img src={loadingBarImage} />
          </div>
        )
        : <a href="#"
             className="faded danger right"
             onClick={() => showRedactPopup(text.docket_seq)}>
             Update/Redact
          </a>;

      if (docketDetails.seqNum && docketDetails.seqNum === text.docket_seq) {
        accum.push((
          <tr key={key} className="details-visible">
            <td>{text.date_filed}</td>
            <td style={{ textAlign: 'center' }}>
              { docketNumLink }
            </td>
            <td colSpan="2">
              <span dangerouslySetInnerHTML={{ __html: text.docket_text }} />
              { loadingOrRedact }
            </td>
          </tr>
        ));

        if (docketDetails.details.length === 0) {
          accum.push((
            <tr key={`details-${key}`} className="docket_details">
              <td colSpan="2" />
              <td className="here" colSpan="100%">No Accessible Documents Found</td>
            </tr>
          ));
        } else {
          accum.push((
            <tr key={`details-${key}`} className="docket_details">
              <td colSpan="2" />
              <td className="here" colSpan="100%">
                <table className="sticky-enabled">
                  <thead>
                    <tr>
                      <th />
                      <th>Part</th>
                      <th>Description</th>
                      <th>Pages</th>
                      <th width="50%">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <DocketParts docketDetails={docketDetails}
                                 buyPdf={buyPdf}
                                 onPopupClick={onPopupClick}
                                 case_uuid={case_uuid}
                                 docket_numbers={docketDetails.seqNum}
                                 reloadDetails={reloadDetails} />
                  </tbody>
                </table>
              </td>
            </tr>
          ));
        }

        return accum;
      }

      const docketDetailLoadingBar = selectedDocketDetailNum === text.docket_seq
        ? <LoadingBar overrideShow />
        : null;

      accum.push((
        <tr key={key}>
          <td>{text.date_filed}</td>
          <td style={{ textAlign: 'center' }}>
            { docketNumLink }
          </td>
          <td colSpan="2">
            <span dangerouslySetInnerHTML={{ __html: text.docket_text }} />
            { loadingOrRedact }
            { docketDetailLoadingBar }
          </td>
        </tr>
      ));

      return accum;
    }, []);
  }

  const { latest_known_date_filed = '' } = dockets.headers.meta;
  const lastUpdatedTitle = `Import Dockets filed from ${latest_known_date_filed}`;

  return (
    <div id="ir-search-dockets-results">
      <table>
        <thead>
          <tr>
            <th style={{ width: '55px', whiteSpace: 'nowrap' }}>
              <div className="item" onClick={sortDockets.bind(null, 'docket_no')}>Date Filed</div>
            </th>
            <th style={{ width: '55px', textAlign: 'center' }}>
              #
            </th>
            <th style={{ width: '110px', textAlign: 'center' }}>
              <div className="item" onClick={sortDockets.bind(null, 'docket_text')}>Docket text</div>
            </th>
            <th id="docket_update_ctrl">
              <span className="ir-search-refresh-date" title={lastUpdated}>
                Last updated &nbsp;
                <span>
                  { window.$.cuteTime({ refresh: 60000 }).cuteTime(lastUpdated) }
                </span>
              </span>
              <div className="ui small secondary menu">
                <div className="item">
                  <div
                    id="update-from-pacer-link"
                    title={lastUpdatedTitle}
                    onClick={updateClick}>
                    <img src="/sites/all/themes/inforuptcy/icons/icon-update.png" height="23" width="23" />
                    Update
                  </div>
                </div>
                <div className="item">
                  <div
                    title="Show/Hide Docket Import Form"
                    onClick={pastEntriesClick}>
                    <img src="/sites/all/themes/inforuptcy/icons/icon-past-entries.png" height="23" width="23" />
                    Past Entries
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody className="docket-entries-table">
          { itemRows }
        </tbody>
      </table>
    </div>
  );
};

DocketEntries.defaultProps = {
  selectedDocketDetailNum: null,
  redactSeqNum: null,
  showMissingDockets: false,
};

DocketEntries.propTypes = {
  entries: PropTypes.array.isRequired,
  lastUpdated: PropTypes.any.isRequired,
  dockets: PropTypes.any.isRequired,
  buyMissingDockets: PropTypes.any.isRequired,
  getDocketDetails: PropTypes.any.isRequired,
  showRedactPopup: PropTypes.any.isRequired,
  buyPdf: PropTypes.any.isRequired,
  case_uuid: PropTypes.any.isRequired,
  sortDockets: PropTypes.any.isRequired,
  updateClick: PropTypes.any.isRequired,
  pastEntriesClick: PropTypes.any.isRequired,
  onPopupClick: PropTypes.func.isRequired,
  reloadDetails: PropTypes.func.isRequired,
  selectedDocketDetailNum: PropTypes.string,
  redactSeqNum: PropTypes.any,
  showMissingDockets: PropTypes.bool,
};

export default DocketEntries;



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/DocketEntries.jsx
 **/